import { TypedUseSelectorHook, useDispatch as useDispatchBase, useSelector as useSelectorBase } from 'react-redux';
import { StoreState, DispatchType } from '../store';

export const useDispatch: () => DispatchType = useDispatchBase;

export const useSelector: TypedUseSelectorHook<StoreState> = useSelectorBase;
